import { render, staticRenderFns } from "./Planilla.vue?vue&type=template&id=23015490&"
import script from "./Planilla.vue?vue&type=script&lang=js&"
export * from "./Planilla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports